import { FormClassApply } from "../../../assets/data/Constants";
import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import { TkGetCode } from "../../../utils/TkGetCode";
import { isStatusAfterApproval } from "../../../utils/useTools";

/**
 * 処理履歴を作成する
 * @param res
 * @returns statusBodyList
 */
function funStatusBodyList(res: any) {
  const statusBodyList: any[] = [];
  for (let i in res) {
    let createDate = new Date(res[i].createDate);
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children:
          createDate.getFullYear() +
          "/" +
          (createDate.getMonth() + 1) +
          "/" +
          createDate.getDate(),
      },
      {
        children: res[i].processComment,
      },
    ];
    statusBodyList.push(data);
  }

  return statusBodyList;
}
/**
 * 中小企業退職金共済契約締結届のダウンロードリンク用のラインのないテーブルを作成する
 * @param res
 * @returns downloadBodyList
 */

function fundownloadBodyList(res: any) {
  const downloadBodyList: any[] = [];
  const shown = isStatusAfterApproval(res.latestApplyStatus);
  if (res.formList) {
    res.formList.forEach((file: any) => {
      switch (file.formClass) {
        case "EXP0601012":
          downloadBodyList.push([
            {
              children: (
                <TkDownloadLink
                  dataname={
                    TkGetCode(FormClassApply, "EXP0601012") +
                    "・" +
                    TkGetCode(FormClassApply, "EXP0601018")
                  }
                  base64filedata={file.fileBase64}
                  downloadBase64={true}
                />
              ),
              width: "50%",
            },
            {
              children: shown ? res.symbolNo.toString() : "",
            },
            { children: shown ? res.approvalDate : "" },
          ]);
          break;
      }
    });
  }

  return downloadBodyList;
}

export { funStatusBodyList, fundownloadBodyList };
